<div class="sa-otp-container flex flex-col">
    @if(showSpinner){
        <div class="sa-otp-spinner-container">
            <div class="flex flex-center flex-col">
                <sa-spinner size="48">
    
                </sa-spinner>
            </div>
            <div class="text-primary sub-title">
                <span>Authenticating...</span>
            </div>
        </div>
    }@else{
        <!-- isPasswordInput: true -->
        <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 6, allowNumbersOnly: true,inputClass: 'sa-otp-input' ,containerClass: 'sa-otp-container' }" [ngClass]="status ? status : ''"></ng-otp-input>
        @if(errorMsg){
            <div class="text-error text-11 otp-error-msg">{{errorMsg}}</div>
        }
    }
</div>